module.exports = __webpack_public_path__ + "media/img/covers/profile-cover-6-e0a1b4d7579314014bf399db7cc4147a.jpg";